import React, { Fragment } from 'react';
import { maxMobileMediaQuery } from '../../styles';
import { useIsClientSide } from './Media.utils';
import { useIsMediaQuery } from './useIsMediaQuery';
export function MobileOnlyMedia(props) {
  const isClientSide = useIsClientSide();
  const isMobile = useIsMediaQuery(maxMobileMediaQuery());
  if (!isClientSide) {
    return typeof props.children === 'function' ? props.children(false) : null;
  }
  return typeof props.children === 'function' ? props.children(isMobile) : isMobile ? React.createElement(Fragment, null, props.children) : null;
}